import { render, staticRenderFns } from "./cabecalho-impressao.vue?vue&type=template&id=a2d31ce6"
import script from "./cabecalho-impressao.vue?vue&type=script&lang=js"
export * from "./cabecalho-impressao.vue?vue&type=script&lang=js"
import style0 from "./cabecalho-impressao.vue?vue&type=style&index=0&id=a2d31ce6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports